module.exports = __webpack_public_path__ + "static/media/NI.87480e3d.svg";